module.exports = __webpack_public_path__ + "assets/img/423c-sj.svg";